module.exports = __webpack_public_path__ + "static/media/lifesaverNormal.071bdbb3.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/lifesaverNormal.svg
// module id = 304
// module chunks = 0